export const APP = {
    linkedin: 'https://www.linkedin.com/in/elbashah/',
    instagram: 'https://www.instagram.com/bash55m/',
    github: 'https://github.com/ElBashah'
}